import type { OrderSettlementEntry } from './types';

// Corrections are single-level financial audit events. A correction may amend
// an automatic PARTIAL or a closing FINAL, but never another CORRECTION.
export function canCorrectSettlementEntry(entry: Pick<OrderSettlementEntry, 'kind'>): boolean {
  return entry.kind === 'PARTIAL' || entry.kind === 'FINAL';
}
